var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.depth === 1
    ? _c(
        "div",
        {
          class: {
            list: true,
            "list--sectors": true,
            "list--loading": _vm.loading,
          },
        },
        [
          _c(
            "table",
            { class: { table: true, "table--loading": _vm.loading } },
            [
              _c("tr", [
                _c("th", [_vm._v("Sector")]),
                _vm._v(" "),
                _vm.counts ? _c("th", [_vm._v("Opportunities")]) : _vm._e(),
                _vm._v(" "),
                _vm.counts ? _c("th", [_vm._v("MADDs")]) : _vm._e(),
                _vm._v(" "),
                _vm.counts ? _c("th", [_vm._v("Intelligence")]) : _vm._e(),
                _vm._v(" "),
                _vm.counts ? _c("th", [_vm._v("Insights")]) : _vm._e(),
                _vm._v(" "),
                _vm.counts ? _c("th", [_vm._v("Experts")]) : _vm._e(),
                _vm._v(" "),
                _vm.actionsSlotFilled ? _c("th") : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.loading
                ? _vm._l(10, function (i) {
                    return _c("tr", { staticClass: "blank-row" }, [
                      _c("td", [_vm._v(" ")]),
                      _vm._v(" "),
                      _vm.counts ? _c("td", [_vm._v(" ")]) : _vm._e(),
                      _vm._v(" "),
                      _vm.counts ? _c("td", [_vm._v(" ")]) : _vm._e(),
                      _vm._v(" "),
                      _vm.counts ? _c("td", [_vm._v(" ")]) : _vm._e(),
                      _vm._v(" "),
                      _vm.counts ? _c("td", [_vm._v(" ")]) : _vm._e(),
                      _vm._v(" "),
                      _vm.counts ? _c("td", [_vm._v(" ")]) : _vm._e(),
                      _vm._v(" "),
                      _vm.actionsSlotFilled
                        ? _c("td", [_vm._v(" ")])
                        : _vm._e(),
                    ])
                  })
                : _vm._l(_vm.sectorList, function (sector) {
                    return [
                      _c("tr", { class: _vm.sectorClasses(sector) }, [
                        _c(
                          "td",
                          {
                            staticClass: "sector__name",
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.toggle(sector.id)
                              },
                            },
                          },
                          [_vm._v(_vm._s(sector.name))]
                        ),
                        _vm._v(" "),
                        _vm.counts
                          ? _c(
                              "td",
                              { staticClass: "opportunities" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to:
                                        "/opportunities?sectors[]=" + sector.id,
                                    },
                                  },
                                  [_vm._v(_vm._s(sector.opportunities))]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.counts
                          ? _c(
                              "td",
                              { staticClass: "madds" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: "/madds?sectors[]=" + sector.id,
                                    },
                                  },
                                  [_vm._v(_vm._s(sector.madds))]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.counts
                          ? _c(
                              "td",
                              { staticClass: "intelligence" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to:
                                        "/intelligence?sectors[]=" + sector.id,
                                    },
                                  },
                                  [_vm._v(_vm._s(sector.intelligence))]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.counts
                          ? _c(
                              "td",
                              { staticClass: "insights" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: "/insights?sectors[]=" + sector.id,
                                    },
                                  },
                                  [_vm._v(_vm._s(sector.insights))]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.counts
                          ? _c(
                              "td",
                              { staticClass: "sector-specialists" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: {
                                        name: "sector-experts",
                                        params: { sector_id: sector.id },
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t" +
                                        _vm._s(sector.experts) +
                                        "\n\t\t\t\t\t"
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.actionsSlotFilled
                          ? _c(
                              "td",
                              { staticClass: "sector__actions" },
                              [_vm._t("actions", null, { sector: sector })],
                              2
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "tr",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.children &&
                                sector.children.length &&
                                _vm.expanded === sector.id,
                              expression:
                                "children && sector.children.length && expanded === sector.id",
                            },
                          ],
                          staticClass: "children",
                        },
                        [
                          _c(
                            "td",
                            { attrs: { colspan: _vm.columnCount } },
                            [
                              _vm.actionsSlotFilled
                                ? _c("ListSectors", {
                                    attrs: {
                                      depth: _vm.depth + 1,
                                      sectors: sector.children,
                                      counts: _vm.counts,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "actions",
                                          fn: function ({ sector }) {
                                            return [
                                              _vm._t("actions", null, {
                                                sector: sector,
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  })
                                : _c("ListSectors", {
                                    attrs: {
                                      depth: _vm.depth + 1,
                                      sectors: sector.children,
                                      counts: _vm.counts,
                                    },
                                  }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  }),
            ],
            2
          ),
          _vm._v(" "),
          _vm.error
            ? _c("div", { staticClass: "list__error" }, [
                _c("span", { staticClass: "h2" }, [
                  _vm._v("Unable to load sectors."),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn--link",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.load.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("Retry")]
                ),
              ])
            : _vm._e(),
        ]
      )
    : _c(
        "table",
        { staticClass: "table" },
        [
          _vm._l(_vm.sectorList, function (sector) {
            return [
              _c("tr", { class: _vm.sectorClasses(sector) }, [
                _c(
                  "td",
                  {
                    staticClass: "sector__name",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.toggle(sector.id)
                      },
                    },
                  },
                  [_vm._v(_vm._s(sector.name))]
                ),
                _vm._v(" "),
                _vm.counts
                  ? _c(
                      "td",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: "/opportunities?sectors[]=" + sector.id,
                            },
                          },
                          [_vm._v(_vm._s(sector.opportunities))]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.counts
                  ? _c(
                      "td",
                      [
                        _c(
                          "router-link",
                          { attrs: { to: "/madds?sectors[]=" + sector.id } },
                          [_vm._v(_vm._s(sector.madds))]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.counts
                  ? _c(
                      "td",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: "/intelligence?sectors[]=" + sector.id,
                            },
                          },
                          [_vm._v(_vm._s(sector.intelligence))]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.counts
                  ? _c(
                      "td",
                      [
                        _c(
                          "router-link",
                          { attrs: { to: "/insights?sectors[]=" + sector.id } },
                          [_vm._v(_vm._s(sector.insights))]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.counts
                  ? _c(
                      "td",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: "sector-experts",
                                params: { sector_id: sector.id },
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(sector.experts) +
                                "\n\t\t\t\t"
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.actionsSlotFilled
                  ? _c(
                      "td",
                      { staticClass: "sector__actions" },
                      [_vm._t("actions", null, { sector: sector })],
                      2
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "tr",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        sector.children.length && _vm.expanded === sector.id,
                      expression:
                        "sector.children.length && expanded === sector.id",
                    },
                  ],
                  staticClass: "children",
                },
                [
                  _c(
                    "td",
                    { attrs: { colspan: _vm.columnCount } },
                    [
                      _vm.actionsSlotFilled
                        ? _c("ListSectors", {
                            attrs: {
                              depth: _vm.depth + 1,
                              sectors: sector.children,
                              counts: _vm.counts,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "actions",
                                  fn: function ({ sector }) {
                                    return [
                                      _vm._t("actions", null, {
                                        sector: sector,
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        : _c("ListSectors", {
                            attrs: {
                              depth: _vm.depth + 1,
                              sectors: sector.children,
                              counts: _vm.counts,
                            },
                          }),
                    ],
                    1
                  ),
                ]
              ),
            ]
          }),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }